module.exports = __webpack_public_path__ + "static/media/studio_articulated_loader_mla_5_50_manitou_002.d24edf9e.png";